<div class="border-0" *ngIf="request && request.status">

  <!-- <button *ngIf="request.setting.code !== 'HCP' && request.status.code !== 'END' && request.status.code !== 'DEL' && request.status.code !== 'CHI'"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#changeSettingModal" data-bs-toggle="modal">
    Cambio Setting
  </button> -->

  <!-- Stato BOZ (BOZZA): Solo Trasmetti -->
  <button *ngIf="request.status.code === 'BOZ' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          (click)="trasmetti()">
    Trasmetti
  </button>

  <!-- Stato NEW (NUOVA RICHIESTA): Cambio competenza e Presa in carico -->
  <button *ngIf="request.status.code === 'NEW' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>
  <button *ngIf="request.status.code === 'NEW' &&  !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          (click)="presaInCarico()">
    Prendi in Carico
  </button>

  <!-- Stato PIC (PRESA IN CARICO): Cambio competenza e Scegli struttura -->
  <button *ngIf="request.status.code === 'PIC' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

  <!-- Stato CS (CONFERMA STRUTTURA): Cambio competenza, Scegli struttura, Conferma paziente -->
  <button *ngIf="request.status.code === 'CS' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

  <!-- Stato CP (CONFERMA PAZIENTE): Cambio competenza e Completa pratica -->
  <button *ngIf="request.status.code === 'CP' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>
  <button *ngIf="request.status.code === 'CP' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'success'" [size]="'xs'" class="me-2"
          data-bs-target="#completeRequestModal" data-bs-toggle="modal"
         >
    Completa Pratica
  </button>

    <!-- Stato DAT (DA TRASMETTERE): Cambio competenza -->
  <button *ngIf="request.status.code === 'DAT' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

      <!-- Stato TPV (TRASMESSA PER VALUTAZIONE): Cambio competenza -->
  <button *ngIf="request.status.code === 'TPV' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>
 <!-- Stato TPA (TRASMESSA PER ARRUOLAMENTO): Cambio competenza E SCEGLI STRUTTURA-->
  <button *ngIf="request.status.code === 'TPA' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

  <!-- Stato VAL (VALUTATA): Cambio competenza E SCEGLI STRUTTURA-->
  <button *ngIf="request.status.code === 'VAL' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

   <!-- Stato CPZ (ARRUOLAMENTO): Cambio competenza E CONFERMA PAZIENTE-->
  <button *ngIf="request.status.code === 'CPZ' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

     <!-- Stato CST (ARRUOLATA): Cambio competenza E COMPLETA-->
  <button *ngIf="request.status.code === 'CST' && (request.ownership.code == authService.getOwnership() || authService.isOperatoreCot)"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
           data-bs-target="#changeOwnerShipModal" data-bs-toggle="modal">
    Cambio Competenza
  </button>

    <button *ngIf="request.status.code === 'CST' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'success'" [size]="'xs'" class="me-2"
          data-bs-target="#completeRequestModal" data-bs-toggle="modal"
         >
    Completa Pratica
  </button>

  <!-- Stato END (COMPLETATA): CHIUDI-->

  <button *ngIf="request.status.code !== 'DEL' && request.status.code !== 'CHI' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#closeRequestModal" data-bs-toggle="modal">
    Chiudi Pratica
  </button>

  <!-- Annulla disponibile in tutti gli stati tranne END (COMPLETATA) -->
  <button *ngIf="request.status.code !== 'END' && request.status.code !== 'DEL' && request.status.code !== 'CHI'"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#deleteRequestModal" data-bs-toggle="modal">
    Annulla richiesta
  </button>

  <button *ngIf="request.status.code === 'DEL'"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          (click)="reopenRequest()">
    Riapri
  </button>
</div>

<it-modal
  #changeOwnerShipModal="itModal"
  alignment="right"
  scrollable="true"
  id="changeOwnerShipModal"
  size="xl"
>
  <ng-container modalTitle>Cambio Competenza</ng-container>
  <!-- <div class="row" *ngIf="isConsentMissing">
    <div class="col">
      <it-alert color="danger">
        Attenzione! Non risulta allegato alla pratica nessun documento di tipo consenso.
      </it-alert>
    </div>
  </div> -->
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-change-ownership [isConsentMissing]="isConsentMissing" (changeConfirmed)="changeOwnerShipConfirmed($event)" (cancelled)="cancelledChangeOwnerShip()" [request]="request"></app-change-ownership>
    </div>
  </div>
</it-modal>

<it-modal
  #changeSettingModal="itModal"
  alignment="right"
  scrollable="true"
  id="changeSettingModal"
  size="xl"
>
  <ng-container modalTitle>Cambio Setting</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-change-setting [request]="request" (changeConfirmed)="changeSettingConfirmed($event)" (cancelled)="cancelledChangeSetting()"></app-change-setting>
    </div>
  </div>
</it-modal>

<it-modal
  #completeRequestModal="itModal"
  alignment="right"
  scrollable="true"
  id="completeRequestModal"
  size="xl"
>
  <ng-container modalTitle>Completa pratica di transizione</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [transitionId]="request.id" [dischargeInfo]="requestDates" [visibleFields]="['facilityRequestDate', 'facilityConfirmDate', 'presumedDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-complete-request-modal (requestConfirmed)="requestConfirmed($event)" (cancelled)="cancelledCompleteRequest()"></app-complete-request-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #deleteRequestModal="itModal"
  alignment="right"
  scrollable="true"
  id="deleteRequestModal"
  size="xl"
>
  <ng-container modalTitle>Annulla la pratica di transizione</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-delete-request-modal (requestDeleted)="requestDeleted($event)" (cancelled)="cancelledDeleteRequest()"></app-delete-request-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #closeRequestModal="itModal"
  alignment="right"
  scrollable="true"
  id="closeRequestModal"
  size="xl"
>
  <ng-container modalTitle>Chiudi la pratica di transizione</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-close-request-modal (requestClosed)="requestClosed($event)" (cancelled)="cancelledCloseRequest()"></app-close-request-modal>
    </div>
  </div>
</it-modal>

<it-modal 
  #confirmModal="itModal" 
  alignment="centered"
  id="genericConfirmModal">
  <ng-container modalTitle>Conferma operazione</ng-container>
    <ng-container modalDescription>{{ confirmMessage }}</ng-container>
    

  <ng-container footer>
    <button
      itButton="primary"
      size="lg"
      type="button"
      (click)="proceedConfirmation()"
    >
      Conferma
    </button>
    <button
      itButton="outline-primary"
      size="lg"
      type="button"
      (click)="cancelConfirmation()"
    >
      Chiudi
    </button>
  </ng-container>
</it-modal>